import { Icon } from "semantic-ui-react";

import "modules/LeadsDashboard/components/SnoozeButtonIcon/SnoozeButtonIcon.scss";

type Props = {
  isSnoozed: boolean;
  disabled?: boolean;
  handleClick: () => void;
};

export const SnoozeButtonIcon = ({ handleClick, isSnoozed, disabled = false }: Props) => (
  <div
    className={`snooze-button-card-user ${isSnoozed ? "snoozed-button-snoozed" : ""} ${disabled ? "snoozed-button-disabled" : ""}`}
    onClick={() => !disabled && handleClick()}
  >
    <div>
      <Icon className={`clock snooze-button-card-icon ${isSnoozed ? "snoozed-button-icon-snoozed" : ""}`} />
    </div>
  </div>
);
